import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { useGetAccountQuery } from '../store/accountUserSettings/accountUserSettings'

export interface UseAccountProps {
  accountId?: string
  refetchOnMountOrArgChange?: boolean | number
}

export const useAccount = ({ accountId, refetchOnMountOrArgChange }: UseAccountProps = {}) => {
  const currentAccountId = useAppSelector(selectAccountId)
  const effectiveAccountId = accountId || currentAccountId
  const { data: account, ...rest } = useGetAccountQuery({ accountId: effectiveAccountId }, { refetchOnMountOrArgChange })

  return {
    accountId: effectiveAccountId,
    account: account?.data,
    ...rest,
  }
}
